import React, {useState, useEffect, useRef, useMemo} from 'react';
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container"
import QuadralAutocomplete from "@quadral/quadral-component-common/dist/components/autocomplete"
import QuadralDate from '@quadral/quadral-component-common/dist/components/date';
import QuadralTextField from "@quadral/quadral-component-common/dist/components/textField"
import QuadralTypography from "@quadral/quadral-component-common/dist/components/typography"
import QuadralButton from "@quadral/quadral-component-common/dist/components/button"
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import QuadralTimeline from "@quadral/quadral-component-common/dist/components/timeline";
import { onlineProcessesService } from '../../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function Assistance({participationId, assistanceRecords, className, roles, formatDate, deviationId, user, quadralToast, showLoader, hideLoader, updateRecord, getTypeIcon, getTypeColor}) {

    const [isFieldsFilled,setIsFieldsFilled] = useState(false);
    const [isDeviation, setIsDeviation] = useState(false);
    // const [ascending, setAscending] = useState('DESC');
    const [timeline, setTimeline] = useState([]);
    const [selected, setSelected] = useState("call");
    const [timeValue, setTimeValue] = useState((new Date()));
    const [date, time] = formatDateTime(new Date());
    const [display, setDisplay] = useState('');
    const [deviation, setDeviation] = useState(0);
    const detailRef = useRef(null);
    const [formData, setFormData] = useState(() => {
        return{
            common: { date, time, escalationMotive: "Justificatif différent de l'attendu", detail: ""},
            call: { callReason: "selectmotive", callConclusion: "", escalationOrigin:""},
            escalation: { escalationStatus: (display === "N2") ? "Retours_a_analyser_interne" : "Retours_a_analyser_externe", subject: ""},
        };
    });
    const [activityRecordBody, setActivityRecordBody] = useState({
        participationId: participationId,
        subject: formData.call.callReason,
        description: formData.common.detail,
        callResult: formData.call.callConclusion,
        origin: formData.call.escalationOrigin
    });                    
    const [assistanceRecordBody, setAssistanceRecordBody] = useState({
        participationId: participationId,
        description: formData.common.detail,
        subject: formData.escalation.subject,
        origin: formData.common.escalationMotive,
        status: formData.escalation.escalationStatus,
    });
    const [updateAssistanceRecordBody, setUpdateAssistanceRecordBody] = useState({
        caseId: deviationId,
        comment: formData.common.detail,
        status: formData.escalation.escalationStatus,
    });

    const motiveOptions = useMemo(() => [
        {   label: "-- Sélectionner un motif --",    value: "selectmotive", },
		{   label: "Global - Compréhension de l'enquête ou d'une relance",    value: "Global - Compréhension de l'enquête ou d'une relance", },
		{   label: "Global - Le client ne dispose pas d'une pièce que nous lui avons demandé",    value: "Global - Le client ne dispose pas d'une pièce que nous lui avons demandé", },
        {   label: "Global - Souhait de confirmer bonne réception du dossier",    value: "Global - Souhait de confirmer bonne réception du dossier", },
        {   label: "Papier - Usage - Accompagnement renseignement formulaire",    value: "Papier - Usage - Accompagnement renseignement formulaire", },
        {   label: "Télédéclaration - Usage - Accompagnement parcours en ligne (accès/saisie/validation)",    value: "Télédéclaration - Usage - Accompagnement parcours en ligne (accès/saisie/validation)", },
        {   label: "Télédéclaration - Usage - Souhait de réponse au format papier",      value: "Télédéclaration - Usage - Souhait de réponse au format papier"     },
        {   label: "Télédéclaration - Usage - Téléchargement des pièces",      value: "Télédéclaration - Usage - Téléchargement des pièces"     },
        {   label: "Télédéclaration - Problème technique",      value: "Télédéclaration - Problème technique"     },
        {   label: "Divers - Autres motifs",      value: "Divers - Autres motifs"     },
    ], []);
    const statusOptions = [
        ...(!isDeviation ? [
            {   label: 'Escaladé interne',    value: 'Escalade_interne', },
		    {   label: 'Escaladé mandant',    value: 'Escalade_externe', },
        ] : []),
        ...(isDeviation ? [
            { label: 'Retours à analyser - interne', value: 'Retours_a_analyser_interne' },
            { label: 'Escaladé mandant', value: 'Escalade_externe' },
            { label: 'Traité', value: 'Traite' },
        ] : []),
    ];
    const statusOptionsAll = useMemo(() => [
        {   label: 'Escaladé interne',    value: 'Escalade_interne', },
		{   label: 'Escaladé mandant',    value: 'Escalade_externe', },
        {   label: 'Retours à analyser - interne',    value: 'Retours_a_analyser_interne', },
		{   label: 'Retours à analyser - mandant',    value: 'Retours_a_analyser_externe', },
        {   label: "Traité", value: "Traite" },
    ], []);
    const escalationOptions = [
        {   label: "Justificatif différent de l'attendu",    value: "Justificatif_different_de_l_attendu", },
        {   label: 'Inadéquation situation déclarée et justificatifs fournis',    value: "Inadequation_situation_declaree_et_justificatifs_fournis", },
        {   label: 'Situation complexe',    value: "Situation_complexe", },
        {   label: 'Autre',    value: "Autre", },
    ]

    useEffect(() => {
        setIsDeviation(!!(deviationId));
    }, [deviationId])

    useEffect(() => {
        if(roles.includes("survey-participation.deviation1")){
            setDisplay('N1');
        }
        if(roles.includes("survey-participation.deviation2")){
            setDisplay('N2');
        }
        if(roles.includes("survey-participation.deviation3")){
            setDisplay('N3');
        }
    }, [roles])

    useEffect(() => {
        if(selected === "call"){
            setActivityRecordBody({
                participationId: participationId,
                subject: formData.call.callReason,
                description: `${user} : ${formData.common.detail}`,
                callResult: !isDeviation ? formData.call.callConclusion : "Resolu",
                origin: formData.call.escalationOrigin
            });
            setIsFieldsFilled(!!(
                participationId && 
                (formData.call.callConclusion || isDeviation) && 
                formData.call.callReason && 
                formData.call.callReason!=="selectmotive" && 
                formData.common.detail.toString().trim() !== ""
            ));
        }else if(!isDeviation){
            setAssistanceRecordBody({
                participationId: participationId,
                description: formData.common.detail,
                subject: formData.escalation.subject,
                origin: formData.common.escalationMotive,
                status: formData.escalation.escalationStatus,
            });
            setIsFieldsFilled(!!(
                participationId &&
                // formData.escalation.escalationStatus && 
                formData.common.escalationMotive &&
                formData.common.detail.toString().trim() !== "" &&
                formData.escalation.subject.toString().trim() !== ""
            ));
        }else{
            setUpdateAssistanceRecordBody({
                caseId: deviationId,
                comment: formData.common.detail,
                status: formData.escalation.escalationStatus,
            });
            setIsFieldsFilled(!!(
                selected !== "call" &&
                formData.common.detail &&
                formData.common.detail.toString().trim() !== ""
            ));
        }
    },[formData, isDeviation, participationId, deviationId, user, selected])


    useEffect(() => {
            const newTimeline = assistanceRecords?.assistances?.map((element) => ({
                title: element.subject
                    ? (motiveOptions.find(opt => opt.value === element.subject)?.label || element.subject)
                    : "Non renseigné",
                content: 
                    <QuadralContainer orientation='column' sx={{gap: "0.5rem"}}>
                        {element.description}
                        <strong>{element.status ? (statusOptionsAll.find(opt => opt.value === element.status)?.label || element.status) : "inconnu"}</strong>
                    </QuadralContainer>,
                time: element.creationDate ? (() => {
                    const [date, time] = element.creationDate.split("T");
                    const timeFormatted = time.substring(0, 5);
                    return `${formatDate(date)} - ${timeFormatted}`;
                })() : "inconnu",
                icon: <FontAwesomeIcon icon={getTypeIcon(element.type)} />,
                iconColor: getTypeColor(element.type),
            }))
    
            setTimeline(newTimeline);
    }, [assistanceRecords, motiveOptions, className, formatDate, statusOptionsAll, getTypeIcon, getTypeColor]);
    
    function createToastError(msg) {
        quadralToast.error(msg, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }

    function setSelectedDetails(value) {
        setSelected(value);
        updateFormSection("call", "callConclusion", "");
    }

    function formatDateTime(date) {
        const twoNum = (n) => (n < 10 ? '0' + n : n);

        const day = twoNum(date.getDate());
        const month = twoNum(date.getMonth() + 1);
        const year = date.getFullYear();
        const hours = twoNum(date.getHours());
        const minutes = twoNum(date.getMinutes());

        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }
    
    function normalizeInputValue(value) {
        return value && value.target ? value.target.value : value;
    }

    function handleChange(newValue, field) {
        const normalizedValue = normalizeInputValue(newValue);
        switch (field){
            case "date" :
                setTimeValue(newValue);
                updateFormSection("common", "date", `${newValue.$D}/${newValue.$M+1}/${newValue.$y}`);
                updateFormSection("common", "time", `${newValue.$H}:${newValue.$m}`);
            break;
            
            case "subject":
            case "escalationStatus":
                updateFormSection("escalation", field, normalizedValue);
                break;

            case "callReason":
            case "callConclusion":
            case "escalationOrigin":
                updateFormSection("call", field, normalizedValue);
                break;

            default:
                updateFormSection("common", field, normalizedValue);
                break;
        }
    }

    function updateFormSection(section, field, newValue) {
        setFormData(formData => ({
            ...formData,
            [section]: {
            ...formData[section],
            [field]: newValue,
            },
        }));
    }

    function sendReport() {
        if (!isFieldsFilled){
            createToastError("Veuillez compléter tous les champs obligatoires s'il vous plait");
            return;
        }else if (selected === "call") {
            return createActivity();
        }else{
            return isDeviation ? updateAssistance() : createAssistance();
        }
    }

    function createActivity(){
        showLoader();
        onlineProcessesService.createActivityRecord({participationId}, activityRecordBody)
            .then(dataReceived => {
                setActivityRecordBody(dataReceived);
                updateRecord();
                hideLoader();
                setDeviation(deviation+1);
                emptyFields();
            })
            .catch(err => {
                console.error(err);
                hideLoader();
        });
    }

    function createAssistance(){
        showLoader();
        onlineProcessesService.createAssistanceRecord({participationId}, assistanceRecordBody)
            .then(dataReceived => {
                setAssistanceRecordBody(dataReceived);
                updateRecord();
                hideLoader();
                emptyFields();
            })
            .catch(err => {
                console.error(err);
                hideLoader();
        });
    }

    function updateAssistance(){
        showLoader();
        onlineProcessesService.updateAssistanceRecord({participationId}, updateAssistanceRecordBody)
            .then(dataReceived => {
                setUpdateAssistanceRecordBody(dataReceived);
                updateRecord();
                hideLoader();
                emptyFields();
            })
            .catch(err => {
                console.error(err);
                hideLoader();
        });
    }

    function emptyFields(){
        handleChange("","callReason");
        handleChange("","detail");
        if(detailRef.current) detailRef.current.value = "";
    }

    return (
        <>
            <div style={{minHeight: '60vh'}} className='container-fluid container-view'>

                <QuadralContainer orientation='row' sx={{borderRadius: '0px'}}>
                    <QuadralContainer orientation='column' col sm={12} md={6} style={{maxHeight:"53rem", overflow: "auto", borderRadius: '0rem'}}>
                        <div style={{display: 'flex', gap: "1rem", alignItems: 'center', marginBottom: '1rem'}}>
                            <span>{assistanceRecords?.totalCount} rapport{assistanceRecords?.totalCount > 1 ? 's' : ''} trouvé{assistanceRecords?.totalCount > 1 ? 's' : ''}</span>
                        </div>
                        <QuadralTimeline timelineLength={assistanceRecords?.totalCount} timeline={timeline}/>
                    </QuadralContainer>
                    {!((!isDeviation && display === "N3") || display === "") &&
                        <QuadralContainer 
                            orientation='column' 
                            sx={{gap: "0.625rem"}}
                            title={
                                display === "N1" ? 'Tracer un appel' : 
                                display === "N2" ? 'Choisissez une action' : 
                                display === "N3" && 'Répondre à une escalade'
                            } 
                            noPaddingTitle
                            sm={12} md={6}
                        >
                            {display === "N2" &&
                                <RadioGroup
                                    name="controlled-radio-buttons-group"
                                    value={selected}
                                    onChange={(e, value) => setSelectedDetails(value)}
                                >
                                    <FormControlLabel
                                        control={<Radio />}
                                        label="Tracer un appel"
                                        value="call"
                                    />

                                    <FormControlLabel
                                        control={<Radio />}
                                        label={isDeviation ? "Répondre à une escalade" : "Créer une escalade"}
                                        value="escalation"
                                    />
                                </RadioGroup>
                            }
                            <QuadralContainer orientation='row'>
                                <QuadralContainer orientation='column' col sm={12} md={7}>
                                    <QuadralDate 
                                        value={timeValue}
                                        disabled={true}
                                        placeholder="jj/mm/aaaa hh:mm"
                                        onChange={(value) => handleChange(value, "date")}
                                        label="Date et heure"
                                        noPadding  
                                        dateAndTime
                                    />
                                </QuadralContainer>
                            </QuadralContainer>
                            {selected === "call" ? (
                                <>
                                <QuadralContainer orientation='column' col sm={12} md={12}>
                                    <QuadralAutocomplete
                                        required
                                        label="Sujet d'appel"
                                        value={motiveOptions.find(o => o.value === formData.call.callReason) ?? null}
                                        onChange={(event, option) => handleChange(option.value, "callReason")}
                                        aria-label="Select Label"
                                        id="callReasonField"
                                        options={motiveOptions}
                                        getOptionLabel={(option) => option.label}
                                        noPadding
                                    />
                                </QuadralContainer>
                                </>
                            ) : !isDeviation ? (
                                <>
                                <QuadralContainer orientation='row'>
                                    <QuadralContainer orientation='column' col sm={12} md={12}>
                                        <QuadralTextField 
                                            required
                                            id="standard-basic" 
                                            label="Sujet"
                                            onChange={(value) => handleChange(value, "subject")}
                                            noPadding
                                        />
                                    </QuadralContainer>
                                </QuadralContainer>
                                </>
                            ) : null }
                            <QuadralContainer orientation='row'>
                                <QuadralContainer orientation='column' col sm={12} md={12}>
                                    <QuadralTextField 
                                        required
                                        label="Commentaire"
                                        id="standard-basic" 
                                        ref={detailRef}
                                        onChange={(value) => handleChange(value, "detail")} 
                                        multiline
                                        rows={4}
                                        noPadding
                                    />
                                </QuadralContainer>
                            </QuadralContainer>
                            {(selected === "call" && !isDeviation)&& (
                                <>
                                <QuadralContainer>
                                    <QuadralTypography variant='label'>Conclusion de l'appel</QuadralTypography>
                                    <RadioGroup
                                        onChange={(event, value) => handleChange(value, "callConclusion")}
                                    >
                                        <FormControlLabel control={<Radio/>} label="Situation résolue" value="Resolu"/>
                                        <FormControlLabel control={<Radio/>} label="Initier une escalade" value="Escalade"/>
                                    </RadioGroup>
                                </QuadralContainer>
                                {(formData.call.callConclusion === "Escalade") && (
                                    <QuadralContainer orientation='row'>
                                        <QuadralContainer orientation='column' col sm={12} md={12}>
                                            <QuadralAutocomplete
                                                label="Motif d'escalade"
                                                value={escalationOptions.find(o => o.value === formData.call.escalationOrigin) ?? ""}
                                                onChange={(event, option) => handleChange(option.value, "escalationOrigin")}
                                                options={escalationOptions}
                                                getOptionLabel={(option) => option.label}
                                                noPadding
                                            />
                                        </QuadralContainer>
                                    </QuadralContainer>
                                )}
                                </>
                            )}
                            {(selected === "escalation" && display === "N2") && (
                                <>
                                <QuadralContainer orientation='row'>
                                    <QuadralContainer orientation='column' col sm={12} md={12}>
                                        <QuadralAutocomplete
                                            label="Statut"
                                            value={statusOptions.find(o => o.value === formData.escalation.escalationStatus) ?? ""}
                                            onChange={(event, option) => handleChange(option.value, "escalationStatus")}
                                            options={statusOptions}
                                            getOptionLabel={(option) => option.label}
                                            noPadding
                                        />
                                    </QuadralContainer>
                                </QuadralContainer>
                                {!isDeviation &&
                                <QuadralContainer orientation='row'>
                                    <QuadralContainer orientation='column' col sm={12} md={12}>
                                        <QuadralAutocomplete
                                            label="Motif d'escalade"
                                            value={escalationOptions.find(o => o.value === formData.common.escalationMotive) ?? ""}
                                            onChange={(event, option) => handleChange(option.value, "escalationMotive")}
                                            options={escalationOptions}
                                            getOptionLabel={(option) => option.label}
                                            noPadding
                                        />
                                    </QuadralContainer>
                                </QuadralContainer>
                                }
                                </>
                            )}
                            <QuadralContainer orientation='row'>
                                <QuadralContainer orientation='column' style={{textAlign: "end"}}>
                                    <QuadralButton
                                        label='Enregistrer'
                                        onClick={() => sendReport()}
                                    />
                                </QuadralContainer>
                            </QuadralContainer>
                        </QuadralContainer>
                    }
                </QuadralContainer>
            </div>
        </>
    );
}